import React from "react";
import { Select } from "./ui";
import CatalogFilterChip from "./sa/CatalogFilterChip";
import { DEFAULT_TABLE_SORT_OPTIONS } from "../utils/tableSort";

const TableSortSelect = ({
  value,
  onChange,
  options = DEFAULT_TABLE_SORT_OPTIONS,
  disabled = false,
  variant = "select",
}: {
  value: string;
  onChange: (value: string) => void;
  options?: { value: string; label: string }[];
  disabled?: boolean;
  /** "chip" renders the oval superadmin toolbar chip (requires an `.sa-list-page` ancestor). */
  variant?: "select" | "chip";
}) =>
  variant === "chip" ? (
    <CatalogFilterChip
      label="Sort"
      value={value}
      options={options}
      onChange={onChange}
      disabled={disabled}
      showAll={false}
    />
  ) : (
    <Select
      className="dash-filter-select dash-table-sort"
      value={value}
      disabled={disabled}
      aria-label="Sort table"
      options={options}
      onChange={onChange}
      placeholder="Sort…"
    />
  );

export default TableSortSelect;
